import { api } from '@/lib/api';
import type { PartEquivalence } from './types';

export interface CreatePartEquivalenceInput {
  partXId: string;
  partYId: string;
  notes?: string | null;
}

/**
 * Part-equivalences REST client over the shared axios instance.
 *
 * Endpoints (Phase 4b):
 *   GET    /part-equivalences?partId=<uuid>   list equivalences
 *                                             touching that part
 *   POST   /part-equivalences                 declare equivalence
 *                                             (admin/superadmin)
 *   DELETE /part-equivalences/:id             remove equivalence
 *                                             (admin/superadmin)
 */
export const partEquivalencesApi = {
  listForPart: async (partId: string): Promise<PartEquivalence[]> => {
    const { data } = await api.get<PartEquivalence[]>('/part-equivalences', {
      params: { partId },
    });
    return data;
  },

  create: async (
    input: CreatePartEquivalenceInput,
  ): Promise<PartEquivalence> => {
    const { data } = await api.post<PartEquivalence>(
      '/part-equivalences',
      input,
    );
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/part-equivalences/${id}`);
  },
};
